import { css } from "@emotion/react"

export const currentPageStyle = css`
	font-weight: bold;
	display: inline;
`

export const container = css`
	margin: 0;

	ul {
		list-style: none;
		padding: 10px 0;
	}

	li {
		display: inline;
	}

	a {
		color: #6b7280;
		font-size: 0.875rem;
		text-decoration: none;
		font-weight: 500;
		cursor: pointer;
	}

	a:focus,
	a:hover {
		color: #0b75e1;
		outline: none;
	}

	a[aria-current="page"] {
		color: #1f2937;
		font-weight: 500;
		cursor: default;
	}
`

export const separator = css`
	color: #9ca3af;
	margin: 0 1rem;
`
